import { Component, OnInit, Inject } from '@angular/core';
import { MasterDataDetails } from '../../models/MasterDataDetails';
import { BasicEmployeeDetails } from '../../models/basicemployeedetails.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../service/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { OnboardingService } from '../../service/onboarding.service';
import { EmployeeService } from '../../service/employee.service';
import { DepartmentsService } from '../../service/departments.service';
import { MasterData } from '../../models/MasterData';
import { PrimarySkills } from '../../models/PrimarySkills';
import { CreateExpertise } from '../../models/AdditionalSkills';

@Component({
  selector: 'app-expertise-dialog',
  templateUrl: './expertise-dialog.component.html',
  styleUrls: ['./expertise-dialog.component.css']
})
export class ExpertiseDialogComponent implements OnInit {
  title: string;
  message: any;
  masterdata: CreateExpertise;
  error: any;
  HREmp: BasicEmployeeDetails;
  empCode: number;
  expbool: Boolean = false;
  ExpertiseForm: FormGroup;
  techGroupList: any[];
  streamList: any[];
  primarySkillsList: any[];
  filteredStreamList: any[];
  filteredPrimarySkillsList: any[];
  type: string;
  keyValueMap = new Map<string, any>();

  constructor(private toastr: ToastrService, private userService: UserService, public dialogRefExp: MatDialogRef<ExpertiseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExpDialog, private formBuilder: FormBuilder, private hrSvc: OnboardingService, private _service: EmployeeService, private deptSvc: DepartmentsService) {
    dialogRefExp.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.techGroupList = data.techgroupList;
    this.streamList = data.streamList;
    this.primarySkillsList = data.primaryskillsList;
    this.type = data.type;
  }
  ngOnInit() {
    this.masterdata = new CreateExpertise();
    this.empCode = this.userService.getEmpCode();
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.ExpertiseForm = this.formBuilder.group({
      TechGroupId: [null],
      StreamId: [null, [Validators.required, Validators.pattern(nonWhitespaceRegExp)]],
      PrimarySkillId:[null, [Validators.required, Validators.pattern(nonWhitespaceRegExp)]]
    });
  }

  onSelectedTechGroupId(techGroupId) {
    var techgrpId = this.techGroupList.find(tech => tech.ID == techGroupId); 
    
      //if (this.expbool == false) {
      //  this.masterdatadetails.MasterGroupID = techGroupId;
      //  this._service.SaveMasterGroupDetails(this.masterdatadetails).subscribe(data => {
      //    this.dialogRefExp.close(this.masterdatadetails);
      //  }, error => this.error = error)
      //}
      //else {
      //  this.toastr.warning("Same Expertise exists");
      //  this.masterdatadetails.Value = null;
      //  this.expbool = false;
      //}
  // this.filteredExpList = this.expertiseList;
   //});

  }

  checkDuplicates() {
    var res;
    if (this.type == 'Techgroup') {
      res = this.techGroupList.find(tech => tech.GroupName.toLowerCase() == this.masterdata.TechGroupName.toLowerCase());
      res && this.keyValueMap.set('Techgroup', true);
    }
    else if (this.type == 'Stream') {
      this.masterdata.TechGroupId = this.techGroupList.find(tech => tech.GroupName == this.masterdata.TechGroupName).ID;
      res = this.streamList.find(stream => stream.StreamName.toLowerCase() == this.masterdata.StreamName.toLowerCase() && stream.TeachGroupId == this.masterdata.TechGroupId);
      res && this.keyValueMap.set('Stream', true);
    }
    else {
      this.masterdata.TechGroupId = this.techGroupList.find(tech => tech.GroupName == this.masterdata.TechGroupName).ID;
      this.masterdata.StreamId = this.streamList.find(tech => tech.StreamName == this.masterdata.StreamName).ID;
      res = this.primarySkillsList.find(ps => ps.Name.toLowerCase() == this.masterdata.PrimarySkillName.toLowerCase() && ps.TeachGroupId == this.masterdata.TechGroupId && ps.StreamId == this.masterdata.StreamId);
      res && this.keyValueMap.set('PrimarySkill', true);
    }
  }

  onSelectedTechgroup() {
    this.masterdata.TechGroupId = this.techGroupList.find(tech => tech.GroupName == this.masterdata.TechGroupName).ID;
    this.filteredStreamList = this.streamList.filter(stream => stream.TeachGroupId == this.masterdata.TechGroupId);
  }

  onSelectedStream() {
    this.masterdata.TechGroupId = this.techGroupList.find(tech => tech.GroupName == this.masterdata.TechGroupName).ID;
    this.masterdata.StreamId = this.streamList.find(tech => tech.Name == this.masterdata.StreamName).ID;
    this.filteredPrimarySkillsList = this.primarySkillsList.filter(skill => skill.TeachGroupId == this.masterdata.TechGroupId && skill.StreamId == this.masterdata.StreamId);
  }

  get f() { return this.ExpertiseForm.controls;}
  async onConfirm(){
    if (!this.ExpertiseForm.invalid) {
      this.masterdata.CreatedBy = this.empCode.toString();
      this.masterdata.ModifiedBy = this.empCode.toString();
      await this.checkDuplicates();
      if (this.keyValueMap.size > 0) {
        this.keyValueMap.forEach((value, key) => {
          this.toastr.warning(`${key} already exists`)
          if (key == 'Techgroup') {
            this.masterdata.TechGroupName = null; this.masterdata.TechGroupId = 0;
          }
          else if (key == 'Stream') {
            this.masterdata.StreamName = null; this.masterdata.StreamId = 0;
          }
          else {
            this.masterdata.PrimarySkillName = null; this.masterdata.PrimarySkillId = 0;
          }
        });
      }
      else {
        this._service.saveTechGroupDetails(this.masterdata).subscribe(data => {
          this.dialogRefExp.close(this.masterdata);
        }, error => this.error = error)
      }
   /*   this.expertiseList.forEach(item => {
        if (item.Value == this.masterdatadetails.Value) {
          this.expbool = true;
        }
      });
      if (this.expbool == false) {
        this.masterdatadetails.MasterGroupID = this.ExpertiseForm.get('TechGroupId').value;
        this._service.SaveMasterGroupDetails(this.masterdatadetails).subscribe(data => {
          this.dialogRefExp.close(this.masterdatadetails);
        }, error => this.error = error)
      }
      else {
        this.toastr.warning("Same Expertise exists");
        this.masterdatadetails.Value = null;
        this.expbool = false;
      }*/

    }
    else {
      return;
    }
  }
  onDismiss(): void {
    this.dialogRefExp.close(false);
  }
}
export class ExpDialog {
  constructor(public title: string, public message: any, public techgroupList: any, public streamList: any,public primaryskillsList:any,public type:string) {
  }
}




